import React, { useState } from "react";
import { 
  EditOptionContainer, 
  EditOptionTitle, 
  EditOptionDescription, 
  FormGroup, 
  Button, 
  ButtonGroup,
  LoadingSpinner,
  TipBox,
  InputSlider,
  Switch
} from "../EditOptionStyles";
import { cropForeground } from "../../utils/editUtils";

const CropForeground = ({ onSubmit, isLoading }) => {
  const [padding, setPadding] = useState(10);
  const [forceRmbg, setForceRmbg] = useState(false);

  const handleSubmit = () => {
    onSubmit({
      editType: "cropForeground",
      options: {
        padding: padding,
        force_rmbg: forceRmbg
      },
      apiFunction: cropForeground
    });
  };

  return (
    <EditOptionContainer>
      <div>
        <EditOptionTitle icon="✂️">Crop Foreground</EditOptionTitle>
        <EditOptionDescription>
          Automatically remove the background and crop tightly around the main subject in your image with customizable padding.
        </EditOptionDescription>
      </div>

      <FormGroup label={`Padding: ${padding}px`}>
        <InputSlider 
          value={padding} 
          onChange={(e) => setPadding(parseInt(e.target.value))} 
          min={0} 
          max={100} 
        />
        <div style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          fontSize: "0.75rem", 
          color: "#888",
          marginTop: "0.25rem" 
        }}>
          <span>No Padding</span>
          <span>Maximum Padding</span>
        </div>
      </FormGroup>

      <FormGroup label="Background Removal">
        <Switch 
          checked={forceRmbg} 
          onChange={setForceRmbg} 
          label="Force Background Removal" 
        />
        <div style={{ 
          fontSize: "0.75rem", 
          color: "#888", 
          marginTop: "0.5rem" 
        }}>
          When enabled, ensures background is completely removed before cropping
        </div>
      </FormGroup>

      <TipBox 
        title="How it Works" 
        icon="💡"
      >
        This feature automatically detects the main subject, removes the background, and crops the image with your specified padding around the edges.
      </TipBox>

      <ButtonGroup>
        <Button 
          primary={false} 
          outline={true}
          onClick={() => {
            setPadding(10);
            setForceRmbg(false);
          }}
        >
          Reset
        </Button>
        <Button 
          onClick={handleSubmit} 
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <LoadingSpinner />
              Processing...
            </>
          ) : (
            "Crop Foreground"
          )}
        </Button>
      </ButtonGroup>
    </EditOptionContainer>
  );
};

export default CropForeground;
